import { getData } from './api'

// 获取租户信息
export const getTenantInfo = (code) => {
  return getData(`system-server/tenant/info/${code}`)
}

// 根据租户ID获取租户信息
export const getTenantInfoById = (tenantId) => {
  return getData(`system-server/tenant/getInfoById/${tenantId}`)
}
